import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  OnChanges,
  HostBinding,
  AfterViewChecked,
  ChangeDetectorRef,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  UserType,
  ProfileUpdateRequestImpl,
  Long,
  UserImpl,
  PasswordChangeRequestImpl,
  ErrorsImpl,
} from "shared/cubiq-model-multi-asset";
import {
  UserPromiseLookupService,
  ActiveUser,
  ProfileSettingKeys,
  PositionBookPromiseLookupService,
  TraderGroupPromiseLookupService,
  ActiveUserProfilePromiseService,
  SystemConfigPromiseService,
  ProfilePromiseActionService,
  LogonResp,
} from "shared/cubiq-services";

import { Router } from "@angular/router";
import * as AuthConst from "./model/bfx-auth.constants";
import { trigger, state, style, transition, animate, AUTO_STYLE } from "@angular/animations";

export enum PasswordField {
  OLD_PASSWORD,
  NEW_PASSWORD,
  NEW_PASSWORD_CONFIRM,
}
import { LoggerService } from "@bfx/logger";
import { BfxAuthService } from "../bfx-common/services/bfx-auth.service";
import { User } from "../bfx-common/models/user.model";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-change-password",
  templateUrl: "./html/bfx-change-password.component.html",
  animations: [
    trigger("errorMessageAnimation", [
      state("void", style({ height: "0px" })),
      state("active", style({ height: AUTO_STYLE })),
      transition(":enter", animate("200ms 100ms ease-in")),
      transition(":leave", [animate("100ms ease-out")]),
    ]),
    trigger("loadingAnimation", [
      state("active", style({ opacity: 1 })),
      state("void", style({ opacity: 0 })),
      transition(":enter", animate("400ms 100ms ease-in")),
      transition(":leave", animate("100ms ease-out")),
    ]),
  ],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class BfxChangePasswordComponent implements OnInit {
  public changePasswordEnabled: boolean = false;
  public changePasswordAvailable: boolean = false;
  public passwordProgress: number = 0;
  public savePasswordDisabled: boolean = true;
  public changePasswordSubmitted: boolean = false;
  public generalPasswordError: string = "";
  public oldPassword: string = "";
  public newPassword: string = "";
  public newPasswordConfirmation: string = "";
  public newPasswordStrength: number = 0;
  public newPasswordStrengthMessage: string = null;
  public newPasswordStrengthColor: string = "";
  public newPasswordSuccess: boolean = false;
  public passwordErrors: any = {};
  public validPasswordField: any = {};
  public failedCheckFields: any = {};

  public get frameTag() {
    return document.body.dataset.frameTag;
  }

  constructor(
    public systemConfigService: SystemConfigPromiseService,
    public positionBookService: PositionBookPromiseLookupService,
    public userService: UserPromiseLookupService,
    public element: ElementRef,
    public authService: BfxAuthService,
    public translationService: TranslateService,
    private _router: Router,
  ) {}

  ngOnInit() {}

  public changePassword(): void {
    this.validatePasswordField(PasswordField.OLD_PASSWORD);
    this.validatePasswordField(PasswordField.NEW_PASSWORD);
    this.validatePasswordField(PasswordField.NEW_PASSWORD_CONFIRM);

    if (this.savePasswordDisabled) {
      return;
    }

    this.savePasswordDisabled = true;
    this.changePasswordSubmitted = true;
    this.generalPasswordError = "";
    this.failedCheckFields = {};

    this.userService
      .changePassword(this.oldPassword, this.newPassword, this.newPasswordConfirmation, true, null)

      .then((response: any) => {
        let error: boolean = false;
        let resetUser: User = null;

        this.changePasswordSubmitted = this.savePasswordDisabled = false;

        if (response != null) {
          let errors: ErrorsImpl = new ErrorsImpl();

          if (errors.encodableType == response.encodableType) {
            error = true;

            let errorMessage: string = this.translationService.instant(
              "user.settings.generic.error",
            );

            this.passwordErrors = {};
            Object.assign(errors, response);
            if (errors.errorMessages != null && errors.errorMessages.length > 0) {
              let errorObject: any = JSON.parse(errors.errorMessages[0] + "");
              errorMessage = this.convertError(errors.errorMessages);

              if (AuthConst.OLD_PASS_ERRORS.indexOf(errorObject.id) >= 0) {
                this.passwordErrors[PasswordField.OLD_PASSWORD] = errorMessage + ".";
                this.failedCheckFields[PasswordField.OLD_PASSWORD] = this.oldPassword;
                this.validPasswordField[PasswordField.OLD_PASSWORD] = false;
                this.savePasswordDisabled = true;
              } else {
                this.passwordErrors[PasswordField.NEW_PASSWORD] = errorMessage;
                this.failedCheckFields[PasswordField.NEW_PASSWORD] = this.newPassword;
                this.validPasswordField[PasswordField.NEW_PASSWORD] = false;
                this.savePasswordDisabled = true;
              }
            }
          } else if (response.username != null && response.password != null) {
            resetUser = response;
          }
        }

        this.newPasswordSuccess = !error;
        this.changePasswordEnabled = error;
        if (this.newPasswordSuccess) {
          if (resetUser != null) {
            this.authService.login(resetUser).then((logonResponse: LogonResp) => {
              logger.out.info(
                `CubiqWorker: requestPasswordReset resolve ` +
                  logonResponse.isSuccess +
                  " errors: " +
                  logonResponse.errors,
              );
              this._router.navigate(["main"]);
            });
          } else {
            this._router.navigate(["main"]);
          }
        }
      })
      .catch((error: any) => {
        this.changePasswordSubmitted = this.savePasswordDisabled = false;
      });
  }

  public cancelChangePassword(): void {
    this._router.navigate(["logout"]);
  }

  public validatePasswordField(passwordField: PasswordField): void {
    let value: boolean = false;
    let errors: Array<string> = [];
    switch (passwordField) {
      case PasswordField.OLD_PASSWORD:
        value =
          this.oldPassword != null &&
          this.failedCheckFields[PasswordField.OLD_PASSWORD] != this.oldPassword;
        if (this.failedCheckFields[PasswordField.OLD_PASSWORD] != this.oldPassword) {
          delete this.failedCheckFields[PasswordField.OLD_PASSWORD];
        }

        if (value === true) {
          this.passwordErrors[PasswordField.OLD_PASSWORD] = "";
        }

        break;
      case PasswordField.NEW_PASSWORD:
        value =
          this.newPassword != null &&
          this.failedCheckFields[PasswordField.NEW_PASSWORD] != this.newPassword;

        if (this.failedCheckFields[PasswordField.NEW_PASSWORD] != this.newPassword) {
          delete this.failedCheckFields[PasswordField.NEW_PASSWORD];
        }

        if (
          this.newPasswordConfirmation != null &&
          this.newPasswordConfirmation.length > 0 &&
          this.newPasswordConfirmation != this.newPassword
        ) {
          this.passwordErrors[PasswordField.NEW_PASSWORD_CONFIRM] = this.translationService.instant(
            "user.settings.passwords.dont.match.error",
          );
          this.validPasswordField[PasswordField.NEW_PASSWORD_CONFIRM] = false;
        } else {
          if (
            this.passwordErrors[PasswordField.NEW_PASSWORD_CONFIRM] ==
            this.translationService.instant("user.settings.passwords.dont.match.error")
          ) {
            this.validPasswordField[PasswordField.NEW_PASSWORD_CONFIRM] = true;
          }
          this.passwordErrors[PasswordField.NEW_PASSWORD_CONFIRM] = "";
        }

        if (value === true) {
          this.passwordErrors[PasswordField.NEW_PASSWORD] = "";
        }

        this.checkPasswordStrength();

        break;
      case PasswordField.NEW_PASSWORD_CONFIRM:
        value =
          this.newPasswordConfirmation != null &&
          this.newPasswordConfirmation.length > 0 &&
          this.newPasswordConfirmation.localeCompare(this.newPassword) == 0;
        this.passwordErrors[PasswordField.NEW_PASSWORD_CONFIRM] = "";

        if (
          this.newPasswordConfirmation != null &&
          this.newPasswordConfirmation.length > 0 &&
          !value
        ) {
          this.passwordErrors[PasswordField.NEW_PASSWORD_CONFIRM] = this.translationService.instant(
            "user.settings.passwords.dont.match.error",
          );
        }

        break;
    }

    this.validPasswordField[passwordField] = value;

    // All three fields need to populated and new password should match confirmation
    let keys: Array<string> = Object.keys(this.validPasswordField);
    this.savePasswordDisabled = !(
      keys.length == Object.keys(PasswordField).length / 2 &&
      keys
        .map((value: string) => this.validPasswordField[value])
        .every((value: boolean) => value != null && value === true)
    );

    if (!this.savePasswordDisabled) {
      this.passwordErrors = {};
    }
  }

  public checkPasswordStrength(): void {
    this.newPasswordStrength = this.calculateStrength(this.newPassword);
    this.newPasswordStrengthMessage = AuthConst.STRENGTH_MESSAGES[this.newPasswordStrength - 1];
    this.newPasswordStrengthColor = AuthConst.STRENGTH_COLORS[this.newPasswordStrength - 1];
  }

  public calculateStrength(password: string): number {
    var strength: number = 0;

    var regSmall: RegExp = new RegExp(/([a-z]+)/);
    var regBig: RegExp = new RegExp(/([A-Z]+)/);
    var regNum: RegExp = new RegExp(/([0-9]+)/);
    var regSpecial: RegExp = new RegExp(/(\W+)/);

    if (password.search(regSmall) != -1) {
      strength++;
    }

    if (password.search(regBig) != -1) {
      strength++;
    }

    if (password.search(regNum) != -1) {
      strength++;
    }

    if (password.search(regSpecial) != -1) {
      strength++;
    }

    return strength;
  }

  /**
   * Creates a translation object with a message as id and
   * parameters as args list from a string
   * @param error the error string as served in ErrorsImpl object
   */
  protected convertError(error: any): string {
    let errorObject = JSON.parse(error + "");
    return this.translationService.instant(errorObject.id, errorObject.args);
  }
}
